import * as React from "react";

/**
 * `value`, but only after it has held still for `delayMs`.
 *
 * Used for the search box on a surface that queries the server per keystroke:
 * the URL still updates immediately (so the address bar stays shareable and
 * the input stays responsive), while the request waits for the typing to
 * stop. Without it, "ForceFieldBundle" is sixteen round trips, fifteen of
 * which are already stale when they land.
 *
 * The timer is cleared on every change and on unmount, so the last value
 * always wins and nothing is set after the component is gone.
 */
export function useDebouncedValue<T>(value: T, delayMs: number): T {
  const [settled, setSettled] = React.useState(value);

  React.useEffect(() => {
    const timer = setTimeout(() => setSettled(value), delayMs);
    return () => clearTimeout(timer);
  }, [value, delayMs]);

  return settled;
}
